import {
  Edit,
  SimpleForm,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  required,
} from "react-admin";

export const AuthUserEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" label="User ID" disabled />
      <TextInput source="email" label="Email" disabled />
      <TextInput source="name" label="Name" disabled />
      <ArrayInput source="roles" label="Roles" validate={required()}>
        <SimpleFormIterator inline>
          <TextInput source="" label="Role" helperText={false} />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);
